import { render, staticRenderFns } from "./CookieConsentModal.vue?vue&type=template&id=32f0d006"
import script from "./CookieConsentModal.vue?vue&type=script&lang=js"
export * from "./CookieConsentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports